<template>
  <v-navigation-drawer
    app
    :value="visible"
    width="330"
    :mini-variant="true"
    expand-on-hover
    style="margin: 1px"
    @input="$emit('update:visible', $event)"
  >
    <slot></slot>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SideMenu",
  props: {
    visible: {
      type: Boolean,
      default: null,
    },
  },
};
</script>
